/**
 * Check the URL for a fragment that has the image dimensions (e.g. '#size=32,32')
 * The migration tool will automatically append this to all of our S3 images
 * @param url the image URL to check for a dimension fragment
 * @returns the width and height of the image, or null if not found
 */
export function GetImageDimensionsFromURLFragment(
  url: string
): [width: number, height: number] | null {
  const regex = /#size=(\d+),(\d+)/;
  const match = url.match(regex);
  const width = Number.parseInt(match?.[1] ?? '');
  const height = Number.parseInt(match?.[2] ?? '');
  if (!Number.isNaN(width) && !Number.isNaN(height)) {
    return [width, height];
  }
  return null;
}
